import qs from "qs";
import {apiVoissa} from "../../libs/api";



export const fetchStories = (query = {}, config = {}) => apiVoissa.get(`/stories?${qs.stringify(query)}`, config);

export const fetchStory = (id = null, query = {}, config = {}) => apiVoissa.get(`/stories/${id}?${qs.stringify(query)}`, config);
export const createStory = (data = {}, config = {}) => apiVoissa.post(`/stories`, data, config);
export const updateStory = (id = null, data = {}, config = {}) => apiVoissa.patch(`/stories/${id}`, data, config);
export const deleteStory = (id = null, config = {}) => apiVoissa.delete(`/stories/${id}`, config);

export const reportStory = (storyId, data = {}, config = {}) => apiVoissa.post(`/stories/${storyId}/reporting`, data, config);

export const STORIES_KEY = `stories`;
export const STORIES_TAGS_KEY = `stories-tags`;

export const STORY_KEY = `story`;